import { mapActions, mapMutations } from 'vuex'
import { getKey, judgeClientSystem, isTMDMiniprogram } from '@/assets/utils'
import { hasNativeMethod, jsBridge } from '@/assets/jsBridge'
import wx from 'weixin-webview-jssdk'
import qs from 'qs'
export default {
  data () {
    return {
      showAuditButton: 'N',
      creditStatus: '',
      lastLoanSerialNo: '',
      creditLiving: '',
      lastLoan: {},
      bizTag: {}
    }
  },
 
  async mounted () {
    // 清空提现页的金额缓存
    const RESET_FORM = { applyAmt: 0, applyTerm: 0, bankCardNo: '', purpose: '' }
    this.$storage.set('withdrawForm', RESET_FORM)
    this.setWithdrawForm(RESET_FORM)
    await this.getUserInfoX({ forceUpdate: true })
 
    /**
     * 校验用户是否是需要去补充资料银行卡的人群
     */
    await this.fillProcess()
   
    /**
     * 校验授信提现流程
     */
    this.getSerialNo()
    this.$bus.$emit('ready')
  },
  methods: {
    ...mapActions('user', ['getLimitX', 'getUserInfoX', 'getBizTag', 'showStatusX', 'getPassIndexCard']),
    ...mapActions('authentication', ['fillProcessX']),
    ...mapActions('withdraw', ['loanApplyProcessX']),
    ...mapMutations('withdraw', ['setWithdrawForm']),
    async getBizTagX () {
      return new Promise(async (resolve, reject) => {
        const { success, data } = await this.getBizTag()
        if (success) {
          this.bizTag = data || {}
          // irr36a引导再次提现
          if (this.bizTag?.guideReApplyTag === 'IRR36A_GUIDE') {
            this.$router.replace('/withdraw/preview-next')
          } else {
            resolve()
          }
        }
      })
    },

    // 检查是否是passcard用户
    async checkIsPasscard () {
      return new Promise(async (resolve, reject) => {
        const params = {}
        if (this.$route.query?.couponSerialNos) {
          params.couponSerialNos = this.$route.query?.couponSerialNos
        }
        const indexCard = await this.getPassIndexCard()
        /**
         * 校验是否是passcard被锁定用户
         */
        if (indexCard.success && indexCard.data?.limitExpireShowType === 'LIMIT_LOCK') { 
          if (hasNativeMethod('navigateTo') && judgeClientSystem() !== 'IOS') {
            jsBridge('exit')
          } else {
            this.$router.replace('/')
          }
          return
        }
        const showStatusRes = await this.showStatusX({ rightsType: 'PASS' })
        
        if (showStatusRes.success) {
          // 有资格 未购买
          const isPasscard = this.bizTag.passCardTag === 'HAVE_QUALIFICATION' && showStatusRes.data
          // 有效的额度
          const unUse = this.bizTag.passCardTag === 'HAVE_EFFECTIVE_LIMIT' && showStatusRes.data
          /**
           * passCardSubTag
           * 1. HAVE_QUALIFICATION_CREDIT 授信输出
           * 2. HAVE_QUALIFICATION_LOAN 提现输出
           */
          const passCardSubTag = this.bizTag.passCardSubTag 
          // 直供页面的pass卡提现结果
          if (['CREDIT_SUCCESS', 'LOAN_INFO', 'LOAN_REFUSED'].includes(this.creditStatus)) {
            if (this.showAuditButton === 'Y') {
              const query = {
                loanApplyNo: this.lastLoanSerialNo
              }
              if (this.$route.query.smsTemplate) {
                query.smsTemplate = this.$route.query.smsTemplate
              }
              this.$router.replace({
                path: '/withdraw/result4',
                ...{ query }
              })
              return
            }
            
            /**
             * 如何unUse 判断最新一笔借据是否是passcard的借据，如果是就跳pass卡的结果页
             * 如果是否就跳pass卡提现流程
             */
            if (unUse && this.lastLoan.riskPassTagNo && ['LOAN_AUDIT', 'LOANING', 'QUEUE', 'LOAN_FAILURE'].includes(this.lastLoan.loanStatus)) {
              this.toWithdrawResult(this.lastLoanSerialNo)
              return
            }
            
            if (isPasscard && passCardSubTag !== 'HAVE_QUALIFICATION_CREDIT') {
              const smsTemplate = this.$route.query.smsTemplate
              this.$router.replace(
                {
                  path: '/withdraw/result3',
                  query: smsTemplate ? { smsTemplate } : null
                }
              )
              return
            }
            
            if (unUse) {
              this.$router.replace(`/withdraw/passcard?${qs.stringify(params)}`)
              return
            }

            if (passCardSubTag === 'HAVE_QUALIFICATION_CREDIT') {
              this.$router.replace(`/authentication/result-pass`)
              return
            }
          }
         
          resolve({ isPasscard: false, unUse: false })
        }
        resolve({ isPasscard: false, unUse: false })
      })
    },

    // 检查是否是upcard用户
    async checkIsUpCard () {
      return new Promise(async (resolve, reject) => {
        const showStatusRes = await this.showStatusX({ rightsType: 'UP' })
        
        if (showStatusRes.success) {
          /**
           * HAVE_QUALIFICATION: 有up卡资格, 
           * HAVE_EFFECTIVE_LIMIT: 有有效未使用额度up卡额度
           * 为空表示没有相关逻辑
           */
          if (this.bizTag.upCardTag === 'HAVE_EFFECTIVE_LIMIT' && showStatusRes.data) {
            this.$router.replace(`/withdraw/upcard`)
            return
          }
        }
        resolve({ isPasscard: false, unUse: false })
      })
    },

    // 借款申请流程查询，该笔申请所处流程
    async loanApplyProcess (loanApplySerialNo) {
      return new Promise(async (resolve, reject) => {
        const { success, data } = await this.loanApplyProcessX({ loanApplySerialNo })
        if (success && data?.upCardProcess) {
          this.$router.replace(`/withdraw/result5?loanApplyNo=${loanApplySerialNo}`)
          return
        }
        resolve()
      })
    },

    async fillProcess () {
      return new Promise(async (resolve, reject) => {
        const { success, data } = await this.fillProcessX()
        if (success) {
          if (data.process === 'NON') {
            resolve()
          } else {
            this.$router.replace(`/authentication/pre-base`)
          }
        }
      })
    },
    async getSerialNo () {
      /**
       * UN_LOGIN UNCREDIT         "未登录"
       * UNCREDIT UNCREDIT         "未授信"
       * PRE_REFUSED REJECTED      "预授信拒绝" 已废弃
       * PRE_SUCCESS UNCREDIT      "预授信成功" 已废弃
       * CREDIT_REVIEW IN_PROGRESS "授信审核中"
       * CREDIT_REFUSED REJECTED   "授信拒绝"
       * CREDIT_SUCCESS CONFIRMED  "授信成功"
       * CREDIT_ERROR FAIL         "授信失败"
       * CREDIT_EXPIRE EXPIRED     "授信过期"
       * LOAN_INFO CONFIRMED       "提现信息"
       * LOAN_REFUSED CONFIRMED    "提现拒绝"
       */

      const { success, data } = await this.getLimitX({
        loanPlatform: 'TMD',
        bizProcess: this.$route.query.isPreview ? 'PASS_CARD' : null
      })

      if (success && data) {
        const {
          creditStatus,
          serialNo,
          creditQueue,
          lastLoanSerialNo,
          loanList,
          showAuditButton,
          creditLiving
        } = data
        this.showAuditButton = showAuditButton
        this.creditStatus = creditStatus
        this.creditLiving = creditLiving
        this.lastLoanSerialNo = lastLoanSerialNo

        if (loanList?.length) {
          this.lastLoan = loanList[0]
        }
        await this.getBizTagX()
        // passcard用户
        await this.checkIsPasscard()
          
        /**
         * 需要排队的用户优先去排队
         */
        if (creditQueue) {
          return this.$router.replace(
            `/authentication/wait?applyNo=${serialNo}`
          )
        }

        /**
         * 校验授信提现流程
         */
        switch (creditStatus) {
          case 'UNCREDIT':
          case 'PRE_SUCCESS':
          case 'CREDIT_EXPIRE':
          case 'CREDIT_ERROR':
            this.toFill() // 补充资料
            break
          case 'CREDIT':
          case 'CREDIT_LOCKED':
          case 'CREDIT_REFUSED':
          case 'CREDIT_REVIEW':
            this.toAuthResult(serialNo) // 授信结果页
            break
          case 'CREDIT_SUCCESS':
          case 'LOAN_INFO':
            this.toWithdraw(loanList)
            break
          case 'LOAN_REFUSED':
            this.toWithdrawResult(lastLoanSerialNo) // 提现封禁 提现结果页
            break
          default:
            break
        }
      }
    },
    nextNodeCommon (nextStep) {
      const params = {}
      if (this.$route.query?.couponSerialNos) {
        params.couponSerialNos = this.$route.query?.couponSerialNos
      }
      switch (nextStep) {
        case 'OCR':
          return { h5: '/authentication/id', native: 'ocr', mp: 'PROCESS' }
        case 'BASE':
          return { h5: '/authentication/base', native: 'basic_info', mp: 'PROCESS' }
        case 'WITHDRAW':
          return { h5: `/withdraw/index?${qs.stringify(params)}`, native: 'withdraw', mp: 'PROCESS' }
      }
    },

    judge (path) {
      if (hasNativeMethod('navigateTo') && !!path.native && (judgeClientSystem() !== 'IOS' || (judgeClientSystem() === 'IOS' && getKey('appChannel') === 'official-iOS'))) {
        jsBridge('navigateTo', { path: path.native, exitCurrent: true, couponSerialNos: this.$route.query.couponSerialNos })
      } else if (isTMDMiniprogram()) {
        wx.miniProgram.postMessage({
          data: { 
            eventType: 'PROCESS'
          }
        })
        wx.miniProgram.navigateBack()
      } else {
        this.$router.replace(path.h5)
      }
    },
    /**
     * 提现流程
     * @param {*} loanList
     * @returns
     */
    async toWithdraw (loanList) {
      /**
       * 针对UP卡首页 如果是需要优先校验上一笔订单
       * 其他情况优先去提现
       */
      if (this.$route.query.flow !== 'H') {
        await this.checkIsUpCard()
      }
      if (loanList?.length) {
        if (['LOAN_AUDIT', 'LOANING', 'QUEUE', 'LOAN_WAIT_UP'].includes(loanList[0].loanStatus)) {
          this.toWithdrawResult(loanList[0].serialNo)
          return
        }
      }
      await this.checkIsUpCard()
      this.judge(this.nextNodeCommon('WITHDRAW'))
    },

    /**
     *  提现结果页
     * @param {*} lastLoanSerialNo
     */
    async toWithdrawResult (lastLoanSerialNo) {
      const userInfo = getKey('userInfo') || {}
      // pass卡等待放款中页面
      if (this.showAuditButton) {
        const query = {
          loanApplyNo: lastLoanSerialNo
        }
        if (this.$route.query.smsTemplate) {
          query.smsTemplate = this.$route.query.smsTemplate
        }
        return this.$router.replace({
          path: '/withdraw/result4',
          ...{ query }
        })
      }

      // 校验是否为up卡流程
      await this.loanApplyProcess(lastLoanSerialNo)

      if (!userInfo.hasDiversion) {
        this.$router.replace(
          `/withdraw/result2?loanApplyNo=${lastLoanSerialNo}`
        )
      } else {
        this.$router.replace(
          `/withdraw/result?loanApplyNo=${lastLoanSerialNo}`
        )
      }
    },

    /**
     * 补充资料
     */
    toFill () {
      let { authStatus } = getKey('userInfo') || {}
      authStatus = authStatus || []
      if (!authStatus.includes('OCR')) {
        this.judge(this.nextNodeCommon('OCR'))
      } else if (authStatus.includes('OCR_EXPIRE')) {
        this.$router.replace('/authentication/supplementaryOCR?status=expired')
      } else if (this.creditLiving === 'PRE_CREDIT_LIVING') {
        this.$router.replace('/authentication/face?redirectUrl=/middle/limit')
      } else {
        this.judge(this.nextNodeCommon('BASE'))
      }
    },

    /**
     * 授信结果页
     * @param {*} serialNo
     */
    async toAuthResult (serialNo) {
      const userInfo = getKey('userInfo') || {}
      const hasDiversionOrInCreditQueue = userInfo.hasDiversion || userInfo.creditQueue
      if (!hasDiversionOrInCreditQueue) {
        this.$router.replace(`/authentication/result2?applyNo=${serialNo}`)
      } else {
        this.$router.replace(`/authentication/result?applyNo=${serialNo}`)
      }
    }
  },
  render () {
    return <div />
  }
}
